var map = {
	"./": 42710,
	"./bnb.png": 30325,
	"./eth.png": 52762,
	"./image-solid.png": 34344,
	"./index": 42710,
	"./index.js": 42710,
	"./metamask.png": 58843,
	"./walletConnectIcon.svg": 69854,
	"./x.svg": 91275
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;